export default __webpack_public_path__ + "static/media/perfume1.00de838b.png";